import { useEffect, useRef } from "react";
import { useSuiteContext } from "./SuiteContextProvider";
import { useActiveCompany } from "@/contexts/ActiveCompanyContext";

/**
 * SuiteContextSync - collega il Foundation Context all'ActiveCompanyContext
 * legacy per garantire retro-compatibilita' con tutte le pagine esistenti
 * (Dashboard, Presenze, Report, Guida, Workflow) che ancora leggono
 * `useActiveCompany()` invece di `useSuiteContext()`.
 *
 * Ruolo:
 *   - Quando lo `SuiteContext.company.id` cambia (via ContextSwitcher /
 *     CommandPalette / History), aggiorna `activeCompanyId` dell'
 *     ActiveCompanyContext, cosi' Dashboard/Presenze/Report ricaricano
 *     automaticamente il dominio.
 *   - Non fa il viceversa: il vecchio selettore azienda (per super_admin)
 *     resta "silenzioso" verso il Foundation Context Engine perche' non
 *     dovrebbe piu' essere usato attivamente in produzione. Puo'
 *     comunque coesistere senza conflitti.
 */
export function SuiteContextSync() {
  const { context } = useSuiteContext();
  const { setActiveCompanyId, activeCompanyId } = useActiveCompany();
  const initialSync = useRef(false);

  useEffect(() => {
    const cid = context?.company?.id || "";
    if (!cid) return;
    if (cid === activeCompanyId) {
      initialSync.current = true;
      return;
    }
    // Aggiorna l'ActiveCompanyContext (che scrive anche in localStorage per
    // i ruoli globali).
    setActiveCompanyId(cid);
    initialSync.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.company?.id]);

  return null;
}
